/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector } from '../../../../infra/hooks';

interface PropsValues {
  setOffboardingWithdrawnData: (data: any) => void;
  setOffboardingData: (data: any) => void;
}

function DTOOffBoardingHistory({
  setOffboardingWithdrawnData,
  setOffboardingData,
}: PropsValues) {
  const storeOffBoardingList = useAppSelector(
    (state) => state.offBoardingListSlice.offBoardingList,
  );
  const storeOffBoardingWithdrawn = useAppSelector(
    (state) => state.offBoardingWithdrawnSlice.offBoardingWithdrawn,
  );

  useEffect(() => {
    setOffboardingWithdrawnData(storeOffBoardingWithdrawn);
    setOffboardingData(storeOffBoardingList);
  }, []);

  useEffect(() => {
    setOffboardingWithdrawnData(storeOffBoardingWithdrawn);
    setOffboardingData(storeOffBoardingList);
  }, [storeOffBoardingWithdrawn, storeOffBoardingList]);

  return <></>;
}
export default DTOOffBoardingHistory;
